import { createFileRoute } from '@tanstack/react-router'

import { RootRoute } from '@/pages/account/route-entries/root-route'

export const Route = createFileRoute('/_layout/_private/app/user')({
  component: RootRoute,
})
